import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { _SharePointQueryableInstance, _SharePointQueryableCollection, spInvokableFactory, } from "../sharepointqueryable.js";
import { defaultPath } from "../decorators.js";
import { Site } from "../sites/types.js";
import { tag } from "../telemetry.js";
var _HubSites = /** @class */ (function (_super) {
    __extends(_HubSites, _super);
    function _HubSites() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Gets a Hub Site from the collection by id
     *
     * @param id The Id of the Hub Site
     */
    _HubSites.prototype.getById = function (id) {
        return tag.configure(HubSite(this, "GetById?hubSiteId='" + id + "'"), "hss.getById");
    };
    _HubSites = __decorate([
        defaultPath("_api/hubsites")
    ], _HubSites);
    return _HubSites;
}(_SharePointQueryableCollection));
export { _HubSites };
export var HubSites = spInvokableFactory(_HubSites);
var _HubSite = /** @class */ (function (_super) {
    __extends(_HubSite, _super);
    function _HubSite() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Gets the ISite instance associated with this hubsite
     */
    _HubSite.prototype.getSite = function () {
        return __awaiter(this, void 0, void 0, function () {
            var d;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.select("SiteUrl")()];
                    case 1:
                        d = _a.sent();
                        return [2 /*return*/, Site(d.SiteUrl)];
                }
            });
        });
    };
    __decorate([
        tag("hs.getSite")
    ], _HubSite.prototype, "getSite", null);
    return _HubSite;
}(_SharePointQueryableInstance));
export { _HubSite };
export var HubSite = spInvokableFactory(_HubSite);
//# sourceMappingURL=types.js.map